import React from 'react';

import { GameArr } from '../../models/GameArr';

type GridPreviewProps = {
  gameArr: GameArr;
};

const GridPreview = ({ gameArr }: GridPreviewProps) => {
  return <div />;
};

export default GridPreview;
